import React from 'react';

import { SVGComponentProps } from './svg.types';

const FinanceOnboardSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherSvgProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherSvgProps}
      >
        <path
          d="M12.6654 16.001C14.8745 16.001 16.6654 14.2101 16.6654 12.001C16.6654 9.79184 14.8745 8.00098 12.6654 8.00098C10.4563 8.00098 8.66541 9.79184 8.66541 12.001C8.66541 14.2101 10.4563 16.001 12.6654 16.001ZM21.6699 4.00391H3.66992C3.11764 4.00391 2.66992 4.45162 2.66992 5.00391V19.0039C2.66992 19.5562 3.11764 20.0039 3.66992 20.0039H21.6699C22.2222 20.0039 22.6699 19.5562 22.6699 19.0039V5.00391C22.6699 4.45162 22.2222 4.00391 21.6699 4.00391ZM4.66992 15.6473V8.35469C5.79569 8.01798 6.6834 7.1299 7.01959 6.00391H18.3112C18.6483 7.13291 19.5398 8.02273 20.6699 8.35738V15.6446C19.5379 15.9798 18.6452 16.8721 18.3094 18.0039H7.02134C6.68648 16.8752 5.79765 15.9846 4.66992 15.6473Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default FinanceOnboardSVG;
